import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Admin Guide Layout
 * Stack navigation for the admin guide/documentation screens
 */
export default function AdminGuideLayout() {
  const router = useRouter();
  const navigation = useNavigation();
  const colors = useThemeColors();

  /**
   * Handle back navigation safely
   */
  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      // Fallback to admin tab
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        contentStyle: { backgroundColor: colors.background },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color={colors.text} />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Handleiding",
        }}
      />
    </Stack>
  );
}
